enum LocalStorage {
    ACCESS_TOKEN = 'dy_internal/access_token',
    REFRESH_TOKEN = 'dy_internal/refresh_token',
    RECENT_WORKSPACES_DATA = 'dy_internal/recent_workspaces_data',
    RESEND_WORKSPACE_VERIFICATION_TIMEOUT = 'dy_internal/resend_workspace_verification_timeout',
}

export default LocalStorage;
